import { createFileRoute } from "@tanstack/react-router"
import { childrenQueryOptions } from "@/features/children/api/children.queries"
import { getSelectedChildId } from "@/features/children/useSelectedChild"
import { historyFrom, sessionsQueryOptions } from "@/features/history/api/history.queries"
import { HistoryPage } from "@/features/history/HistoryPage"

export const Route = createFileRoute("/_app/historik")({
  loader: async ({ context }) => {
    const children = await context.queryClient.ensureQueryData(childrenQueryOptions)
    const childId = getSelectedChildId(children)
    if (childId) {
      await context.queryClient.ensureQueryData(sessionsQueryOptions(childId, historyFrom()))
    }
  },
  component: HistoryPage,
})
